import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { authClient } from "../oidcClientFront";
import { getCurrentUser, login } from "../authService";

const Login = () => {
  const [searchParams] = useSearchParams();
  const authError = searchParams.get("authError") === "1";

  useEffect(() => {
    if (authError) return; // не зацикливаем автологин, если бэк уже вернул ошибку

    const checkUser = async () => {
      console.log("Login...");
      const user = await getCurrentUser();
      console.log("check user: ", user);
      if (user && !user.expired) {
        // пользователь уже авторизован
        window.location.href = "/";
        return;
      }
      login();
    };

    checkUser();
  }, [authError]);

  if (authError) {
    return (
      <div>
        <p>Не вдалося виконати вхід. Спробуйте ще раз.</p>
        <button onClick={() => login()}>Повторити вхід</button>
      </div>
    );
  }

  return <div>Redirecting to login...</div>;
};

export default Login;
